/* unplugin-vue-components disabled */import { render } from "./QuizQuestionCorrectionExplanation.vue?vue&type=template&id=6b39db1a&scoped=true&ts=true"
import script from "./QuizQuestionCorrectionExplanation.vue?vue&type=script&lang=ts"
export * from "./QuizQuestionCorrectionExplanation.vue?vue&type=script&lang=ts"

import "./QuizQuestionCorrectionExplanation.vue?vue&type=style&index=0&id=6b39db1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b39db1a"]])

export default __exports__